import builder from '../builder';
import RatingStarRibbon from '../../streamline-icons/light/rating-star-ribbon.svg';

export default builder('IconRatingStarRibbonLight', RatingStarRibbon);
